import { config } from "~/config";

export function getFaqParam() {
	return new URL(window.location.href).searchParams.get('faq') || "";
}

export function setFaqArticleParam(objectId: string) {
	const url = new URL(window.location.href);
	const hasArticle = url.searchParams.has('faq');

	if (hasArticle && url.searchParams.get('faq') === objectId) {
		return;
	}

	url.searchParams.set('faq', objectId);

	if (hasArticle) {
		window.history.pushState({}, '', url);
	} else {
		window.history.replaceState({}, '', url);
	}
}

/**
 * Check if any of the queries match any of the tests
 */
export function matchSearch(group: string[], tests: string[]) {
	if (group.length === 0) {
		return true;
	}

	for (const query of group) {
		for (const test of tests) {
			if (test.toLowerCase().includes(query)) {
				return true;
			}
		}
	}

	return false;
}

export function isFaqLink(url: string, catalogId: string): boolean {
	// https://master.cao.app/faqs/faqCatalog:ff1yrfvzg7rhixrz73en/item/faqArticle:fbw40jklv4wce8xk7dnz
	const DOCUMENT_REGEX = new RegExp(`https://${config.deepLinkEndpoint}/faqs/${catalogId}/item/faqArticle:[a-z0-9]{16}`);
	return DOCUMENT_REGEX.test(url);
}